import React, { Fragment, Component } from 'react';
import { observable } from 'mobx';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NumberField from '../numberfield/numberfield.component';
import Sign from './sign.component';
import { observer } from 'mobx-react/index';
import './areafield.scss';

@observer
export default class AreaField extends Component {
    static defaultProps = {
        errors: '',
        description: () => {},
        disabled: false
    };

    static propTypes = {
        field: PropTypes.object.isRequired,
        description: PropTypes.func,
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool
    };

    @observable edited: false;
    @observable editing: false;
    @observable fieldA: 0;
    @observable fieldB: 0;
    @observable fieldR: 0;
    @observable fieldAVal: 0;
    @observable fieldBVal: 0;
    @observable fieldRVal: 0;

    /**
     * if provided with a value use this for
     * the displayValue. If not provided with
     * a value, get it from lookupRValue;
     */
    constructor(props) {
        super(props);
        this.fieldA = React.createRef();
        this.fieldB = React.createRef();
        this.fieldR = React.createRef();
    }

    componentDidMount(prevProps) {
        if (this.fieldRVal === 0) {
            this.calculateResult();
        }
    }

    componentDidUpdate(prevProps) {
        this.props.field.map((currentField, index) => {
            switch (index) {
                case 0:
                    this.fieldAVal = currentField.value || 0;
                    break;
                case 1:
                    this.fieldBVal = currentField.value || 0;
                    break;
                default:
                    this.fieldRVal = currentField.value || 0;
                    break;
            }

            return this.fieldRVal;
        });
    }

    /**
     * On blur of the rvalue field, if left blank,
     * fetch the default rvalue for the required
     * params for this element
     * @param e
     */
    onBlur(e) {
        let { value } = e.target;

        if (!value || value === '') {
            value = this.calculateResult();

            this.editing = false;
            this.edited = false;
            this.fieldRVal = value;

            return;
        }

        this.editing = false;
    }

    /**
     * Called from constructor hence we pass in props
     */
    toggleEditable(e, id) {
        this.editing = !this.editing;

        const input = document.getElementById(id),
            ios = document.documentElement.classList.contains('ios');

        // ios won't automatically open the keyboard
        // so don't auto focus, as this:
        // a. causes confusion &
        // b. interrupts editing without a timeout set
        if (!ios) {
            input.focus();
        }
    };

    /**
     * On change of the rvalue field, set the
     * displayValue to whatever the user types
     */
    handleChange(e, refName) {
        const { field } = this.props,
            { value, name } = e.target,
            refVal = `${refName}Val`;

        // set the value on the child field on the form
        field.$(name).set('value', value);
        this[refVal] = value;
        this.calculateResult();

        return value;
    }

    handleChangeResult(e) {
        const { field } = this.props,
            { name, value } = e.target;

        field.$(name).set(value);
        this.fieldRVal = value;
    }

    calculateResult(update = true) {
        const { field } = this.props,
            { fieldAVal, fieldBVal } = this,
            result = (fieldAVal * fieldBVal).toFixed(2);

        field.$(this.fieldR.props.name).set(result);

        if (update) {
            this.fieldRVal = result;

            // set the value on the result field on the form
            field.$(this.fieldR.props.name).set(result);
        }

        return result;
    }

    // eslint-disable-next-line react/sort-comp
    getField(field, refName) {
        return (
            <NumberField
                key={field.name}
                errors={field.errors()}
                {...field.bind()}
                {...field.get('extra')}
                onChange={e => this.handleChange(e, refName)}
                ref={c => (this[refName] = c)}
                value={field.value}
                min={0}
            />
        );
    }

    getResultField(field) {
        const { editing } = this,
            { actionName, ...extra } = field.extra;

        return <Fragment key={field.name}>
            <div className='ht-areafield-result'>
                <NumberField
                    errors={field.errors()}
                    {...field.bind()}
                    {...extra}
                    onChange={e => this.handleChangeResult(e)}
                    onBlur={e => this.onBlur(e)}
                    ref={c => (this.fieldR = c)}
                    value={field.value}
                    readOnly={!editing || field.readOnly}
                    min={0}
                />
            </div>
            {!field.disabled && (
                <button
                    id={`${field.name}-edit`}
                    type='button'
                    className='ht-areafield-editbutton'
                    onClick={(e) => this.toggleEditable(e, field.id)}
                    data-action={actionName}
                >
                    Edit
                </button>
            )}
        </Fragment>;
    }

    render() {
        const { field, label } = this.props,
            { description } = field.extra,
            { editing, edited } = this,
            fieldClasses = classNames('ht-field ht-areafield', {
                'ht-areafield--editing': editing,
                'ht-areafield--edited': edited
            }),
            helperText = description && description() ? description() : false;

        return <div className={fieldClasses}>
            <fieldset>
                <div className='ht-areafield-legend'>
                    {label && (
                        <legend className='bx--label'>{label}</legend>
                    )}
                    {helperText && (
                        <div className='bx--form__helper-text'>
                            {helperText}
                        </div>
                    )}
                </div>
                <div className='ht-areafield-fields'>
                    {field.map((currentField, index) => {
                        switch (index) {
                            case 0:
                                return <Fragment key='fieldA'>
                                    {this.getField(
                                        currentField,
                                        'fieldA'
                                    )}
                                    <Sign sign='x'/>
                                </Fragment>;
                            case 1:
                                return <Fragment key='fieldB'>
                                    {this.getField(
                                        currentField,
                                        'fieldB'
                                    )}
                                    <Sign sign='='/>
                                </Fragment>;
                            default:
                                return <Fragment key='fieldR'>
                                    {this.getResultField(currentField)}
                                </Fragment>;
                        }
                    })}
                </div>
            </fieldset>
        </div>;
    }
}
